import MetaCrmWidget from "./MetaCrmWidget";

export default MetaCrmWidget;
